import i18nextInstance from 'i18next';
import { initReactI18next } from 'react-i18next';
import styleguideEn from '../translations/modules/en.js';
import styleguideCy from '../translations/modules/cy.js';

function initI18next(langcode, translations = []) {
  i18nextInstance.use(initReactI18next).init({
    lng: langcode,
    preload: ['en', 'cy'],
    fallbackLng: false,
    debug: false,
    ns: ['local', 'styleguide'],
    defaultNS: 'local',
    interpolation: {
      escapeValue: false
    },
    react: {
      transKeepBasicHtmlNodesFor: ['p', 'ul', 'li', 'br', 'strong']
    }
  });

  i18nextInstance.addResourceBundle('en', 'styleguide', styleguideEn);
  i18nextInstance.addResourceBundle('cy', 'styleguide', styleguideCy);

  translations.forEach((translation) =>
    i18nextInstance.addResourceBundle(translation.langcode, 'local', translation.json)
  );

  return i18nextInstance;
}

export default initI18next;
